import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as cpfHelp from '@/cpf.help';
let FilterBtn = class FilterBtn extends Vue {
    toggle() {
        if (!this.data.disabled) {
            this.data.selected = !this.data.selected;
            if (this.data.selected) {
                console.log(`${this.data.id}`);
                console.log(`   entails ${this.data.entails}`);
                console.log(`   inhibits ${this.data.inhibits}`);
            }
            this.$emit('entails-inhibits', this.data.selected, this.data.entails, this.data.inhibits);
        }
        else {
            console.log(`cannot selected disabled`);
        }
    }
    get id() {
        return cpfHelp.idify(this.data.name);
    }
    get iconClass() {
        return `${(this.data.selected ? "fad" : "far")} ${this.data.faIcon}`;
    }
    get linkTitle() {
        return this.data.disabled ? `${this.data.selected ? "Selected and" : ""} Disabled by related filter(s)\r\nClear the Filter(s) to Re-enable\r\nCannot '${this.linkTitleCore}'` : this.linkTitleCore;
    }
    get linkTitleCore() {
        return this.data.selected ? `Remove filter for ${this.data.description}` : `Filter for ${this.data.description}`;
    }
};
tslib_1.__decorate([
    Prop()
], FilterBtn.prototype, "data", void 0);
FilterBtn = tslib_1.__decorate([
    Component
], FilterBtn);
export default FilterBtn;
